import { ImageType } from '@/types/gameTypes';
import { formatMessage } from '@/utils';

import {
  BIG_OUTFIT,
  LARGE_BREAKPOINT,
  MEDIUM_BREAKPOINT,
  MEDIUM_OUTFIT,
  SMALL_OUTFIT,
} from './constants';
import { GameClickProps, GameTileProps, GridSizeType } from './types';

export const selectProperStyles = (
  style: {
    small: string | string[];
    medium: string | string[];
    default: string | string[];
  },
  size?: GridSizeType
) => {
  switch (size) {
    case 'small':
      return style.small;
    case 'medium':
      return style.medium;
    default:
      return style.default;
  }
};

export const sliceGameList = (
  expectedAmount: number,
  gameList: GameTileProps[] = []
): GameTileProps[] =>
  [...gameList, ...new Array(expectedAmount)].slice(0, expectedAmount);

export const prepareGameInfoTooltip = (
  gameInfoTooltip: string | undefined,
  gameTitle: string
) =>
  formatMessage(gameInfoTooltip, {
    gameTitle,
  });

export const getOutfitSize = (windowWidth: number) => {
  if (
    windowWidth >= MEDIUM_BREAKPOINT.min &&
    windowWidth <= MEDIUM_BREAKPOINT.max
  ) {
    return MEDIUM_OUTFIT;
  } else if (windowWidth >= LARGE_BREAKPOINT.min) {
    return BIG_OUTFIT;
  }
  return SMALL_OUTFIT;
};

export const verifyImage = (asset?: ImageType) => {
  return !!(
    asset &&
    asset.alt.trim() !== '' &&
    asset.source?.base?.trim() !== '' &&
    !asset.source?.base?.includes('json') &&
    asset.source.normal.includes('assets')
  );
};

export const verifyLottieAnimation = (asset?: ImageType) =>
  !!(
    asset &&
    asset.alt.trim() !== '' &&
    asset.source?.base?.trim() !== '' &&
    asset.source?.base?.includes('json')
  );

export const handleClick = (gamePosition: number, fn: Function) => (
    game: GameClickProps,
    path?: string
  ) => {
    fn({ game, gamePosition, path });
  };